/** @typedef {'clean'|'flagged'|'unknown'} ContentSeverity */

/** @type {readonly string[]} */
export const SEVERITY_SIGNAL_KEYWORDS = [
  "explicit",
  "adult",
  "18+",
  "sexual",
  "nudity",
  "violence",
  "gore",
  "horror",
  "disturbing",
  "mature themes",
  "graphic",
  "ecchi",
  "hentai",
  "nsfw",
  "mature 17",
  "rated mature",
  "sex",
  "porn",
  "xxx",
];

/**
 * Scan free text (name, description, Play rating line) for disturbing content signals.
 * @param {string} text
 * @returns {{ severity: ContentSeverity, hits: string[] }}
 */
export function scanContentSeverity(text) {
  const hay = String(text || "").toLowerCase();
  if (!hay.trim()) {
    return { severity: "unknown", hits: [] };
  }

  /** @type {string[]} */
  const hits = [];
  for (const kw of SEVERITY_SIGNAL_KEYWORDS) {
    if (hay.includes(kw.toLowerCase())) hits.push(kw);
  }

  if (hits.length > 0) {
    return { severity: "flagged", hits };
  }
  return { severity: "clean", hits: [] };
}

/**
 * Merge two severity results (stricter wins: flagged > unknown > clean).
 * @param {ContentSeverity} a
 * @param {ContentSeverity} b
 * @returns {ContentSeverity}
 */
export function mergeSeverity(a, b) {
  if (a === "flagged" || b === "flagged") return "flagged";
  if (a === "unknown" || b === "unknown") return "unknown";
  return "clean";
}
